import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import FourDGame from "./SubComponents/FourD/FourDGame";
import RightTable from "./SubComponents/RightTable/RightTable";
import ColokBebas from "./SubComponents/ColokBebas/ColokBebas";
import ColokJitu from "./SubComponents/ColokJitu/ColokJitu";
import ColokBebas2D from "./SubComponents/ColokBebas2D/ColokBebas2D";
import ColokNaga from "./SubComponents/ColokNaga/ColokNaga";
import TengahDasar from "./SubComponents/TengahDasar/TengahDasar";
import Shio from "./SubComponents/Shio/Shio";
import MacauShio from "./SubComponents/MacauShio/MacauShio";
import FiftyFifty2D from "./SubComponents/FiftyFifty2D/FiftyFifty2D";
import FiftyFifty from "./SubComponents/FiftyFifty/FiftyFifty";
import Result from "../Header/HeaderRightMenu/Result";
import Kombinasi from "./SubComponents/Kombinasi/Kombinasi"
import SilangKembang from "./SubComponents/SilangKembang/SilangKembang";
import { useDispatch, useSelector } from "react-redux";
import ColokBebasversiWap from "./SubComponents/ColokBebas/ColokBebasVersiWap";
import ColokBebas2DVersiWap from "./SubComponents/ColokBebas2D/ColokBebas2DVersiWap";
import ColokJituVersiWap from "./SubComponents/ColokJitu/ColokJituVersiWap";
import ColokNagaVersiWap from "./SubComponents/ColokNaga/ColokNagaVersiWap";
import FiftyFiftyVersiWap from "./SubComponents/FiftyFifty/FiftyFiftyVersiWap";
import FiftyFifty2DVersiWap from "./SubComponents/FiftyFifty2D/FiftyFifty2DVersiWap";
import KombinasiVersiWap from "./SubComponents/Kombinasi/KombinasiVersiWap";
import MacauShioVersiWap from "./SubComponents/MacauShio/MacauShioVersiWap";
import ShioVersiWap from "./SubComponents/Shio/ShioVersiWap";
import { set4dGameSubChildtype, set4dGameSubtype, setCommonConfig } from "../../redux/actions";
import VersiWAP from "./MobileDesign/FourDMo/Versi_WAPP_mo/Versi_WAP_mo";
import KombinasiMo from "./SubComponents/Kombinasi/KombinasiMo";
import MarketClose from "./SubComponents/MarketClose";
import ZeroBalancePopup from "../LobbyContent/SubComponents/ZeroBalancePopup";
import GameClosedPopup from "../LobbyContent/SubComponents/GameClosedPopup";
import QuickBuy from "./SubComponents/FourD/QuickBuy/QuickBuy";
import Bbfs from "./SubComponents/FourD/Bbfs/Bbfs";
import PolaTarung from "./SubComponents/FourD/PolaTarung/PolaTarung";
import ThreeDDepan from "./SubComponents/FourD/ThreeDDepan/ThreeDDepan";
import TwoDDepan from "./SubComponents/FourD/TwoDDepan/TwoDDepan";
import TwoDTengah from "./SubComponents/FourD/TwoDTengah/TwoDTengah";
import BalakBalikVersiWap from "./SubComponents/FourD/BalakBalik/BalakBalikVersiWap";
import { withTranslation } from "react-i18next";
import BolakBalikMain from "./SubComponents/FourD/BalakBalik/BolakBalikMain";
import GameBlocked from "./SubComponents/GameBlocked";
import snowfallbtn from "../../../src/assets/images/FestiveTheme/reset-snow.svg";
import snowfallbtnmo from "../../../src/assets/images/FestiveTheme/reset-snow-mo.svg";
import { makeAjax, respStatus, showMessage, url } from "../../helpers/global_helper";
import InnerPopup from "../Popups/InnerPopup";
import CloseIcon from "../../assets/images/Icons/close_icon.svg";
import FiveSixDGame from "./SubComponents/FiveSixD/FiveSixDGame";
import FiveDSixDMain from "./SubComponents/FiveSixD/FiveDSixDMain";

const LobbyContent = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const app_type = useSelector(state => state.CommonConfig.app_type);
  const device = useSelector(state => state.CommonConfig.device_type);
  const marketStatus = useSelector((state) => state.CommonConfig.discount);
  const subGameOnOffStatus = useSelector((state) => state.CommonConfig.subGameOnOffStatus);
  const marketCloseStatus = useSelector((state) => state.CommonConfig.marketCloseStatus);
  const gameBlockStatus = useSelector((state) => state.CommonConfig.gameBlockStatus);
  const allowed_games = useSelector((state) => state.CommonConfig.allowed_games);
  const game_id = useSelector((state) => state.CommonConfig.game_id);
  const user_balance = useSelector(state => state.UserBalance.user_balance);
  const { game_code } = useParams();
  const location = useLocation();
  const PromoStatus = useSelector((state) => state.CommonConfig.promoStatus);
  const coachMarkStatus = useSelector((state) => state.CommonConfig.coachMarkStatus);
  const [showPromoPopup, setShowPromoPopup] = useState(false);
  const [bannerImg, setBannerImg] = useState('');
  const [bannerId, setBannerId] = useState('');
  const [banner, setBanner] = useState([]);
  const [doNotShowAgain, setDoNotShowAgain] = useState(false);

  useEffect(() => {
    if (PromoStatus === 1) {
      const currentDate = new Date().toISOString().split("T")[0];

      makeAjax(url.PLAYER_API.getPromoBanner, { date: currentDate }, url.PLAYER_MS_EXT).then((response) => {
        if (response.status !== respStatus["SUCCESS"]) {
          showMessage(response);
          return;
        }
        setBanner(response.data[0])
        const storedPreference = localStorage.getItem("promoPopupTimerTG");
        if (storedPreference) {
          let { expiration } = JSON.parse(storedPreference);
          if (new Date().getTime() > expiration) {
            localStorage.removeItem("promoPopupTimerTG");
            localStorage.removeItem("PopupIdArrayTG");
          }
        }

        for (const element of response.data) {
          const parsedPopupIdArray = JSON.parse(localStorage.getItem("PopupIdArrayTG")) || [];

          if (parsedPopupIdArray) {
            if (!parsedPopupIdArray.includes(element.id)) {
              // if (element.redirect_link === 'home' || element.redirect_link === 'promotion') {
               if (element.flag_homepopup === 1) {
                setShowPromoPopup(true);
                setBannerId(element.id);
                setBannerImg(element.updated_homepage_popup);
                break;
              }
            }
          }
        }
      });
    }
  }, [PromoStatus, coachMarkStatus]);

  const donotChecked = (e) => {
    setDoNotShowAgain(e.target.checked);
  }

  const handleBannerClick = (banner) => {
    if (banner.flag_homepopup === 1 && banner.url_homepopup) {
      window.open(banner.url_homepopup, "_blank");
      return;
    }

  };

  const donotShowChange = () => {
    const newId = bannerId;
    setDoNotShowAgain(doNotShowAgain);
    if (doNotShowAgain) {
      let expiration = new Date().getTime() + 7 * 24 * 60 * 60 * 1000; // 7 days in milliseconds
      const existingExpiration = JSON.parse(localStorage.getItem("promoPopupTimerTG"));

      if (!existingExpiration) {
        localStorage.setItem(
          "promoPopupTimerTG",
          JSON.stringify({ expiration })
        );
      }

      const existingArray = JSON.parse(localStorage.getItem("PopupIdArrayTG")) || [];
      // Check if the ID already exists to prevent duplicates
      if (!existingArray.includes(newId)) {
        existingArray.push(newId);
      }

      // Save the updated array back to localStorage
      localStorage.setItem("PopupIdArrayTG", JSON.stringify(existingArray));
    }
  }

  const handleClosePopup = () => {
    setShowPromoPopup(false);
    dispatch(setCommonConfig({ key: 'promoStatus', value: 0 }))
  };

  const gameTypeObj = {
    Quick_Buy: "quickbuy", FiveSix_D: "5d6d", Four_D: "4d3d2d", ThreeDDepan: "ThreeDDepan", TwoDDepan: "TwoDDepan", TwoDTengah: "TwoDTengah", bolak_balik: "bolak_balik", Colok_Bebas: "colokbebas", Colok_Bebas_2D: "colokbebas2d", Colok_Jitu: "colokjitu", Colok_Naga: "coloknaga",
    Fifty_Fifty: "5050", Fifty_Fifty_2D: "50502d", Macau_Shio: "macaushio", Shio: "shio", Tengah_Dasar: "tengahtepi", Kombinasi: "kombinasi",
    Silang_Kembang: "silanghomo", Bbfs: "bbcampuran", pola_tarung: "polatarung",
  }

  // useEffect(() => {
  //   // Christmas theme effect
  //   const applyChristmasTheme = () => {
  //     const buttons = document.querySelectorAll([".reset", ".submit"]); // Select all buttons with the "reset" class
  //     buttons.forEach((btn) => {
  //       const hasImage = btn.querySelector("img"); // Check if the image already exists
  //       if (!hasImage) {
  //         const span = document.createElement("span");
  //         const img = document.createElement("img");
  //         img.src = device === "Mobile" ? snowfallbtnmo : snowfallbtn; // Ensure `snowfallbtn` is a valid variable containing a URL or import
  //         img.alt = "";
  //         span.appendChild(img);
  //         btn.appendChild(span);
  //       }
  //     });
  //   };

  //   applyChristmasTheme();

  //   // Optional: Reapply the theme on DOM updates (e.g., route changes, dynamic content)
  //   const observer = new MutationObserver(() => applyChristmasTheme());
  //   observer.observe(document.body, { childList: true, subtree: true });
  //   return () => observer.disconnect(); // Clean up the observer on unmount
  // }, [device]);

  useEffect(() => {
    dispatch(setCommonConfig({ key: 'gameType', value: gameTypeObj[game_code] ? gameTypeObj[game_code] : '4d3d2d' }))
    dispatch(set4dGameSubtype({
      key: "game_sub_type", value: gameTypeObj[game_code] === "quickbuy" ? 'QUICK_BUY' : (
        gameTypeObj[game_code] === "ThreeDDepan" ? '3DDEPAN' :
          (gameTypeObj[game_code] ? gameTypeObj[game_code] : '4d3d2d')
      )
    }));

    dispatch(setCommonConfig({ key: 'subGameType', value: gameTypeObj[game_code] === "ThreeDDepan" ? '3DDEPAN' : gameTypeObj[game_code] }));

    if (gameTypeObj[game_code] === "ThreeDDepan" || gameTypeObj[game_code] === "TwoDDepan" || gameTypeObj[game_code] === "TwoDTengah") {
      dispatch(setCommonConfig({ key: 'gameType', value: '4d3d2d' }));
    }
  }, [game_code])

  const contentMap = {
    Quick_Buy: (marketStatus.subGameStatus == 0 || subGameOnOffStatus == 0) ? <GameClosedPopup /> :
      (gameBlockStatus) ? <GameBlocked /> :
        (
          (
            marketStatus.marketStatus == 0 ||
            marketCloseStatus == 0 ||
            (allowed_games !== null
              && !allowed_games?.allowed_game_id.split(',').includes(String(game_id)))
          ) ? <MarketClose
            gameAllowed={allowed_games !== null && !allowed_games?.allowed_game_id.split(',').includes(String(game_id)) ? allowed_games?.message : ''}
          /> :
            <div className="full_width">
              {/* {device === "Mobile" && <VersiWAP />} */}
              {app_type === 'wap' ? (
                <QuickBuy />
              ) : (
                <QuickBuy />
              )}
            </div>
        ),
    FiveSix_D: (
      marketStatus.subGameStatus == 0 ? <GameClosedPopup /> : (gameBlockStatus) ? <GameBlocked /> :
        marketStatus.marketStatus == 0 || (allowed_games !== null && !allowed_games?.allowed_game_id.split(',').includes(String(game_id))) ? <MarketClose gameAllowed={allowed_games !== null && !allowed_games?.allowed_game_id.split(',').includes(String(game_id)) ? allowed_games?.message : ''} />
          :
          <div className="full_width">
            <FiveDSixDMain />
          </div>
    ),
    Four_D: (
      marketStatus.subGameStatus == 0 ? <GameClosedPopup /> : (gameBlockStatus) ? <GameBlocked /> :
        marketStatus.marketStatus == 0 || (allowed_games !== null && !allowed_games?.allowed_game_id.split(',').includes(String(game_id))) ? <MarketClose gameAllowed={allowed_games !== null && !allowed_games?.allowed_game_id.split(',').includes(String(game_id)) ? allowed_games?.message : ''} />
          :
          <FourDGame />
    ),
    ThreeDDepan: (
      (gameBlockStatus) ? <GameBlocked /> :
        marketStatus.marketStatus == 0 || (allowed_games !== null && !allowed_games?.allowed_game_id.split(',').includes(String(game_id))) ? <MarketClose gameAllowed={allowed_games !== null && !allowed_games?.allowed_game_id.split(',').includes(String(game_id)) ? allowed_games?.message : ''} />
          :
          <div className="full_width">
            <ThreeDDepan />
          </div>
    ),
    TwoDDepan: (
      (gameBlockStatus) ? <GameBlocked /> :
        marketStatus.marketStatus == 0 || (allowed_games !== null && !allowed_games?.allowed_game_id.split(',').includes(String(game_id))) ? <MarketClose gameAllowed={allowed_games !== null && !allowed_games?.allowed_game_id.split(',').includes(String(game_id)) ? allowed_games?.message : ''} />
          :
          <div className="full_width">
            <TwoDDepan />
          </div>
    ),
    TwoDTengah: (
      (gameBlockStatus) ? <GameBlocked /> :
        marketStatus.marketStatus == 0 || (allowed_games !== null && !allowed_games?.allowed_game_id.split(',').includes(String(game_id))) ? <MarketClose gameAllowed={allowed_games !== null && !allowed_games?.allowed_game_id.split(',').includes(String(game_id)) ? allowed_games?.message : ''} />
          :
          <div className="full_width">
            <TwoDTengah />
          </div>
    ),
    bolak_balik: (
      (gameBlockStatus) ? <GameBlocked /> :
        marketStatus.marketStatus == 0 || (allowed_games !== null && !allowed_games?.allowed_game_id.split(',').includes(String(game_id))) ? <MarketClose gameAllowed={allowed_games !== null && !allowed_games?.allowed_game_id.split(',').includes(String(game_id)) ? allowed_games?.message : ''} />
          :
          <div>
            <BolakBalikMain />
          </div>
    ),
    Colok_Bebas: (
      (marketStatus.subGameStatus == 0 || subGameOnOffStatus == 0) ? <GameClosedPopup /> : (gameBlockStatus) ? <GameBlocked /> : ((marketStatus.marketStatus == 0 || marketCloseStatus == 0 || (allowed_games !== null && !allowed_games?.allowed_game_id.split(',').includes(String(game_id)))) ? <MarketClose gameAllowed={allowed_games !== null && !allowed_games?.allowed_game_id.split(',').includes(String(game_id)) ? allowed_games?.message : ''} />
        :
        <div className="full_width">
          {/* {device === "Mobile" && <VersiWAP />} */}
          {app_type === 'wap' ? <ColokBebasversiWap /> : <ColokBebas />}
        </div>
      )
    ),
    Colok_Bebas_2D: (
      (marketStatus.subGameStatus == 0 || subGameOnOffStatus == 0) ? <GameClosedPopup /> : (gameBlockStatus) ? <GameBlocked /> : ((marketStatus.marketStatus == 0 || marketCloseStatus == 0 || (allowed_games !== null && !allowed_games?.allowed_game_id.split(',').includes(String(game_id)))) ? <MarketClose gameAllowed={allowed_games !== null && !allowed_games?.allowed_game_id.split(',').includes(String(game_id)) ? allowed_games?.message : ''} />
        :
        <div className="full_width">
          {/* {device === "Mobile" && <VersiWAP />} */}
          {app_type == 'wap' ? <ColokBebas2DVersiWap /> : <ColokBebas2D />}
        </div>
      )
    ),
    Colok_Jitu: (
      (marketStatus.subGameStatus == 0 || subGameOnOffStatus == 0) ? <GameClosedPopup /> : (gameBlockStatus) ? <GameBlocked /> : ((marketStatus.marketStatus == 0 || marketCloseStatus == 0 || (allowed_games !== null && !allowed_games?.allowed_game_id.split(',').includes(String(game_id)))) ? <MarketClose gameAllowed={allowed_games !== null && !allowed_games?.allowed_game_id.split(',').includes(String(game_id)) ? allowed_games?.message : ''} />
        :
        <div className="full_width">
          {/* {device === "Mobile" && <VersiWAP />} */}
          {app_type == 'wap' ? <ColokJituVersiWap /> : <ColokJitu />}
        </div>
      )
    ),
    Colok_Naga: (
      (marketStatus.subGameStatus == 0 || subGameOnOffStatus == 0) ? <GameClosedPopup /> : (gameBlockStatus) ? <GameBlocked /> : ((marketStatus.marketStatus == 0 || marketCloseStatus == 0 || (allowed_games !== null && !allowed_games?.allowed_game_id.split(',').includes(String(game_id)))) ? <MarketClose gameAllowed={allowed_games !== null && !allowed_games?.allowed_game_id.split(',').includes(String(game_id)) ? allowed_games?.message : ''} />
        :
        <div className="full_width">
          {/* {device === "Mobile" && <VersiWAP />} */}
          {app_type == 'wap' ? <ColokNagaVersiWap /> : <ColokNaga />}
        </div>

      )
    ),
    Fifty_Fifty: (
      (marketStatus.subGameStatus == 0 || subGameOnOffStatus == 0) ? <GameClosedPopup /> : (gameBlockStatus) ? <GameBlocked /> : ((marketStatus.marketStatus == 0 || marketCloseStatus == 0 || (allowed_games !== null && !allowed_games?.allowed_game_id.split(',').includes(String(game_id)))) ? <MarketClose gameAllowed={allowed_games !== null && !allowed_games?.allowed_game_id.split(',').includes(String(game_id)) ? allowed_games?.message : ''} />
        :
        <div className="full_width">
          {/* {device === "Mobile" && <VersiWAP />} */}
          {app_type == 'wap' ? <FiftyFiftyVersiWap /> : <FiftyFifty />}
        </div>
      )
    ),
    Fifty_Fifty_2D: (
      (marketStatus.subGameStatus == 0 || subGameOnOffStatus == 0) ? <GameClosedPopup /> : (gameBlockStatus) ? <GameBlocked /> : ((marketStatus.marketStatus == 0 || marketCloseStatus == 0 || (allowed_games !== null && !allowed_games?.allowed_game_id.split(',').includes(String(game_id)))) ? <MarketClose gameAllowed={allowed_games !== null && !allowed_games?.allowed_game_id.split(',').includes(String(game_id)) ? allowed_games?.message : ''} />
        :
        <div className="full_width">
          {/* {device === "Mobile" && <VersiWAP />} */}
          {app_type == 'wap' ? <FiftyFifty2DVersiWap /> : <FiftyFifty2D />}
        </div>
      )
    ),
    Macau_Shio: (
      (marketStatus.subGameStatus == 0 || subGameOnOffStatus == 0) ? <GameClosedPopup /> : (gameBlockStatus) ? <GameBlocked /> : ((marketStatus.marketStatus == 0 || marketCloseStatus == 0 || (allowed_games !== null && !allowed_games?.allowed_game_id.split(',').includes(String(game_id)))) ? <MarketClose gameAllowed={allowed_games !== null && !allowed_games?.allowed_game_id.split(',').includes(String(game_id)) ? allowed_games?.message : ''} />
        :
        <div className="full_width">
          {/* {device === "Mobile" && <VersiWAP />} */}
          {app_type == 'wap' ? <MacauShioVersiWap /> : <MacauShio />}
        </div>
      )
    ),
    Shio: (
      (marketStatus.subGameStatus == 0 || subGameOnOffStatus == 0) ? <GameClosedPopup /> : (gameBlockStatus) ? <GameBlocked /> : ((marketStatus.marketStatus == 0 || marketCloseStatus == 0 || (allowed_games !== null && !allowed_games?.allowed_game_id.split(',').includes(String(game_id)))) ? <MarketClose gameAllowed={allowed_games !== null && !allowed_games?.allowed_game_id.split(',').includes(String(game_id)) ? allowed_games?.message : ''} />
        :
        <div className="full_width">
          {/* {device === "Mobile" && <VersiWAP />} */}
          {app_type == 'wap' ? <ShioVersiWap /> : <Shio />}
        </div>
      )
    ),
    Tengah_Dasar: (
      (gameBlockStatus) ? <GameBlocked /> : marketStatus.marketStatus == 0 || (allowed_games !== null && !allowed_games?.allowed_game_id.split(',').includes(String(game_id))) ? <MarketClose gameAllowed={allowed_games !== null && !allowed_games?.allowed_game_id.split(',').includes(String(game_id)) ? allowed_games?.message : ''} />
        :
        <TengahDasar />),
    Kombinasi: (
      (marketStatus.subGameStatus == 0 || subGameOnOffStatus == 0) ? <GameClosedPopup /> : (gameBlockStatus) ? <GameBlocked /> : ((marketStatus.marketStatus == 0 || marketCloseStatus == 0 || (allowed_games !== null && !allowed_games?.allowed_game_id.split(',').includes(String(game_id)))) ? <MarketClose gameAllowed={allowed_games !== null && !allowed_games?.allowed_game_id.split(',').includes(String(game_id)) ? allowed_games?.message : ''} />
        :
        <div className="full_width">
          {device === "Mobile" && (
            <>
              <KombinasiMo />

            </>
          )}
          {app_type === 'wap' ? <Kombinasi /> : <Kombinasi />}
        </div>
      )
    ),
    Silang_Kembang: (
      (gameBlockStatus) ? <GameBlocked /> : marketStatus.marketStatus == 0 || (allowed_games !== null && !allowed_games?.allowed_game_id.split(',').includes(String(game_id))) ? <MarketClose gameAllowed={allowed_games !== null && !allowed_games?.allowed_game_id.split(',').includes(String(game_id)) ? allowed_games?.message : ''} />
        :
        <SilangKembang />),
    Bbfs: (
      (marketStatus.subGameStatus == 0 || subGameOnOffStatus == 0) ? <GameClosedPopup /> : (gameBlockStatus) ? <GameBlocked /> : (gameBlockStatus) ? <GameBlocked /> : ((marketStatus.marketStatus == 0 || marketCloseStatus == 0 || (allowed_games !== null && !allowed_games?.allowed_game_id.split(',').includes(String(game_id)))) ? <MarketClose gameAllowed={allowed_games !== null && !allowed_games?.allowed_game_id.split(',').includes(String(game_id)) ? allowed_games?.message : ''} />
        :
        <div className="full_width">
          <Bbfs />
        </div>
      )
    ),
    pola_tarung: (
      (marketStatus.subGameStatus == 0 || subGameOnOffStatus == 0) ? <GameClosedPopup /> : (gameBlockStatus) ? <GameBlocked /> : ((marketStatus.marketStatus == 0 || marketCloseStatus == 0 || (allowed_games !== null && !allowed_games?.allowed_game_id.split(',').includes(String(game_id)))) ? <MarketClose gameAllowed={allowed_games !== null && !allowed_games?.allowed_game_id.split(',').includes(String(game_id)) ? allowed_games?.message : ''} />
        :
        <div className="full_width">
          <PolaTarung />
        </div>
      )
    ),
  };




  let content;
  if (location.pathname === "/result") {
    content = <Result />;
  } else {
    content =

      (
        <div className="lobby_content">
          <div className="lobby_content_left">
            {contentMap[game_code] || contentMap["Four_D"] || "Page Not Found"}
          </div>
          <div className="lobby_content_right">
            <RightTable />
          </div>
          {

            showPromoPopup &&
            <>
              <div className="modal_overlay" onClick={() => {
                handleClosePopup();
                donotShowChange();
              }}
              > </div>
              <div className="modal frontBanner">
                <button
                  onClick={() => {
                    handleClosePopup();
                    donotShowChange();
                  }}
                  className="modal_close"
                >
                  <img src={CloseIcon} alt="" />
                </button>

                <div className="modal_body">
                  <img src={bannerImg} alt="Promotion Banner" onClick={() => handleBannerClick(banner)}/>

                </div>
                <div className="game_status_popup_footer">
                  <label className="do_not_show_checkbox">
                    <input
                      type="checkbox"
                      id={bannerId}
                      checked={doNotShowAgain}
                      onChange={(e) => donotChecked(e)}
                    />
                    Do not show this again
                  </label>
                </div>
              </div>
            </>


          }
        </div>
      )

  }
  return <div className="lobby">{content}</div>;
};
export default withTranslation()(LobbyContent);
